/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOverwolfGameBodySteamData
 */
export interface CreateOverwolfGameBodySteamData {
    /**
     * Game display name
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    name?: string;
    /**
     * Full game description
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    description?: string;
    /**
     * Brief game description
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    shortDescription?: string;
    /**
     * Game genres
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBodySteamData
     */
    genres?: Array<string>;
    /**
     * Game developers
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBodySteamData
     */
    developers?: Array<string>;
    /**
     * Game publishers
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBodySteamData
     */
    publishers?: Array<string>;
    /**
     * Game release date
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    releaseDate?: string;
    /**
     * Header image URL (460x215)
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    headerImage?: string;
    /**
     * Capsule image URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    capsuleImage?: string;
    /**
     * Capsule image v5 URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    capsuleImageV5?: string;
    /**
     * Background image URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    background?: string;
    /**
     * Raw background image URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    backgroundRaw?: string;
    /**
     * Game website URL
     * @type {string}
     * @memberof CreateOverwolfGameBodySteamData
     */
    website?: string;
}

export function CreateOverwolfGameBodySteamDataFromJSON(json: any): CreateOverwolfGameBodySteamData {
    return CreateOverwolfGameBodySteamDataFromJSONTyped(json, false);
}

export function CreateOverwolfGameBodySteamDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOverwolfGameBodySteamData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'shortDescription': !exists(json, 'shortDescription') ? undefined : json['shortDescription'],
        'genres': !exists(json, 'genres') ? undefined : json['genres'],
        'developers': !exists(json, 'developers') ? undefined : json['developers'],
        'publishers': !exists(json, 'publishers') ? undefined : json['publishers'],
        'releaseDate': !exists(json, 'releaseDate') ? undefined : json['releaseDate'],
        'headerImage': !exists(json, 'headerImage') ? undefined : json['headerImage'],
        'capsuleImage': !exists(json, 'capsuleImage') ? undefined : json['capsuleImage'],
        'capsuleImageV5': !exists(json, 'capsuleImageV5') ? undefined : json['capsuleImageV5'],
        'background': !exists(json, 'background') ? undefined : json['background'],
        'backgroundRaw': !exists(json, 'backgroundRaw') ? undefined : json['backgroundRaw'],
        'website': !exists(json, 'website') ? undefined : json['website'],
    };
}

export function CreateOverwolfGameBodySteamDataToJSON(value?: CreateOverwolfGameBodySteamData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'shortDescription': value.shortDescription,
        'genres': value.genres,
        'developers': value.developers,
        'publishers': value.publishers,
        'releaseDate': value.releaseDate,
        'headerImage': value.headerImage,
        'capsuleImage': value.capsuleImage,
        'capsuleImageV5': value.capsuleImageV5,
        'background': value.background,
        'backgroundRaw': value.backgroundRaw,
        'website': value.website,
    };
}


